module.exports = __webpack_public_path__ + "static/media/product-pills.8d8e1977.svg";